"use client";

import { Filterkopf, Filterzurueck, Luecke, Schiene, Suchfeld, useAnsicht, Zaehlknopf } from "@/components/liste";
import { SPENDER_PARAMS } from "@/lib/spenden/ansicht";

/** Kopf des Spenderregisters: Suche, Personen/Firmen, offene Bestätigungen. */
export function SpenderFilterkopf({
  q,
  art,
  offen,
  zaehler,
}: {
  q: string;
  art: string;
  offen: boolean;
  zaehler: { offen: number; personen: number; firmen: number };
}) {
  const { setzen, isPending } = useAnsicht();
  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={q} platzhalter="Name, Nummer, Ort, Mail …" beschriftung="Spender durchsuchen" />
          <Luecke />
          <Schiene>
            <Zaehlknopf label="Personen" anzahl={zaehler.personen} aktiv={art === "personen"} onClick={() => setzen({ art: art === "personen" ? null : "personen" })} />
            <Zaehlknopf label="Firmen" anzahl={zaehler.firmen} aktiv={art === "firmen"} onClick={() => setzen({ art: art === "firmen" ? null : "firmen" })} />
          </Schiene>
          <Schiene>
            <Zaehlknopf
              label="Offene Bestätigungen"
              anzahl={zaehler.offen}
              aktiv={offen}
              titel="Spender mit mindestens einer Spende ohne Bestätigung"
              onClick={() => setzen({ offen: offen ? null : "1" })}
            />
          </Schiene>
          <Filterzurueck anzahl={[q, art, offen ? "1" : ""].filter(Boolean).length} params={SPENDER_PARAMS} savedViews={false} />
        </>
      }
    />
  );
}
